import {Loader} from '@mantine/core';
import {COMMUNITY} from '../../../../config/constants/routes';
import {useGetCommunityTopicList} from '../../../../core/repositories/communityRepository';
import {CommonLink} from '../../../../shared/components/CommonLink';

export const FollowingTopicList: React.FC = () => {
  const {data, isLoading} = useGetCommunityTopicList({
    followed: true,
    limit: 5,
  });

  return (
    <div className="bg-white rounded-12 shadow-modal">
      <div className="p-12 border-b-[1px] border-line border-collapse">
        <p className="text-base text-black-1 font-bold">
          フォロー中のトピックの新着
        </p>
      </div>
      {isLoading ? (
        <div className="h-64 flex justify-center items-center">
          <Loader color="gray" />
        </div>
      ) : data?.ok && data.value.topics.length > 0 ? (
        <ul className="p-12">
          {data.value.topics.map((topic) => (
            <li
              key={`following-topic-${topic.id}`}
              className="border-b-[1px] border-line border-collapse pb-12 mb-12 [&:nth-last-child(1)]:border-b-0 [&:nth-last-child(1)]:pb-0 [&:nth-last-child(1)]:mb-0"
            >
              <CommonLink
                href={`${COMMUNITY}/${topic.id}`}
                className="hover:opacity-80"
              >
                <div className="overflow-hidden">
                  <p className="text-base text-black-1 font-bold leading line-clamp-1">
                    {topic.title}
                  </p>
                </div>
                <div className="overflow-hidden">
                  <p className="text-base text-black-1 leading line-clamp-1">
                    {topic.body}
                  </p>
                </div>
              </CommonLink>
            </li>
          ))}
        </ul>
      ) : (
        <div className="p-12">
          <p className="text-base text-black-1 leading">
            フォロー中のトピックはありません
          </p>
        </div>
      )}
    </div>
  );
};
